<template>
    <div>
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <!-- Seção: Endereço da Sede -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço da Sede'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-map-marker"></i>
                        Localização
                    </h4>
                    <EnderecoFields
                        ref="endereco"
                        v-model="localPJ"
                        :countries="listaPaises"
                        :field-map="addressFieldMap"
                        id-prefix="pj-headquarters-address"
                        @change="salvarAlteracoesLocalmente"
                    />
                </div>
            </div>
        </section>
        <ModalAlerta v-if="modalAlerta.mostrar" :mostrar="modalAlerta.mostrar" :tipo="modalAlerta.tipo" :titulo="modalAlerta.titulo" :mensagem="modalAlerta.mensagem" @fechar="modalAlerta.mostrar = false" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import EnderecoFields from '@/components/EnderecoFields.vue';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';
export default {
    name: 'CadastroPJ_Endereco',
    props: ['informacoesEndereco', 'Edicao'],
    components: { LabelDisclaimer, ModalAlerta, EnderecoFields },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            listaPaises: 'GET_LISTA_PAISES',
        }),
    },
    data() {
        return {
            modalAlerta: {
                mostrar: false,
                tipo: 'warning',
                titulo: '',
                mensagem: ''
            },
            camposObrigatorios: {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            },
            addressFieldMap: {
                number: 'LogradouroNumero',
                complement: 'LogradouroComplemento'
            },
            permitirAvancar: false,
            localPJ: this.informacoesEndereco
        }
    },
    mounted() {
        this.validarFormulario();
    },
    methods: {
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            };
            const addressValidation = this.$refs.endereco?.validate(Boolean(submeter));
            if (!addressValidation?.valid) {
                if (submeter && this.permitirAvancar) {
                    nomeDoCampo = addressValidation?.firstInvalidLabel || 'País';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo obrigatório',
                    mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`
                };
            }
            return this.permitirAvancar;
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 6);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_ENDERECO', this.localPJ);
            this.validarFormulario();
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
</style>
